import React, { useState } from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';
import { Instagram, LinkedIn } from '@mui/icons-material';
import XIcon from '@mui/icons-material/X';
import EmailModal from '../EmailModal';


const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);
  const handleSendEmail = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <EmailModal
        open={isModalOpen}
        handleClose={handleClose}
        handleSendEmail={handleSendEmail}
      />
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-main">
            <div className="footer-brand">
              <div className="footer-logo">
                <div className="logo-icon">
                  <span>C</span>
                </div>
                <span className="logo-text">CLOUDLAB</span>
              </div>
              <p className="brand-subtitle">Product of AIM</p>
            </div>

            {/* Center: Navigation links */}
            <div className="footer-nav">
              {/* Explore section */}
              <div className="nav-section">
                <h3 className="nav-title">EXPLORE</h3>
                <nav className="nav-links">
                  <a href="https://machinehack.com/" className="nav-link" target="_blank" rel="noopener noreferrer">
                    About MachineHack
                  </a>
                  <a href="https://datalyze.machinehack.com/" className="nav-link" target="_blank" rel="noopener noreferrer">
                    About Datalyze
                  </a>
                </nav>
              </div>

              {/* Legal section */}
              <div className="nav-section">
                <h3 className="nav-title">LEGAL</h3>
                <nav className="nav-links">
                  <Link to="/terms" className="nav-link">
                    Terms of Service
                  </Link>
                  <Link to="/privacy" className="nav-link">
                    Privacy Policy
                  </Link>
                  <Link to="/refund-policy" className="nav-link">
                    Cancellation & Refund Policy
                  </Link>
                </nav>
              </div>
            </div>

            {/* Right: Contact button */}
            <div className="footer-contact">
              <button className="contact-btn" onClick={handleOpen}>Contact Us</button>
            </div>
          </div>

          {/* Bottom section */}
          <div className="footer-bottom">
            <div className="footer-bottom-content">
              {/* Copyright left */}
              <p className="copyright-left">© Copyright Kruxonomy Consulting Pvt Ltd</p>

              {/* Social icons center */}
              <div className="social-icons">
                <a href="https://www.instagram.com/machinehack/" target="_blank" rel="noopener noreferrer" className="social-link">
                  <Instagram className="social-icon" />
                </a>
                <a href="https://www.linkedin.com/company/machine-hack/" target="_blank" rel="noopener noreferrer" className="social-link">
                  <LinkedIn className="social-icon" />
                </a>
                <a href="https://x.com/JoinMachinehack" target="_blank" rel="noopener noreferrer" className="social-link">
                  <XIcon className="social-icon" />
                </a>
              </div>

              {/* Rights reserved right */}
              <p className="copyright-right">© 2025 All rights reserved</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
